module.exports = __webpack_public_path__ + "img/lestrade_logo.9c4281a2.svg";